import { IconSelect } from '@consta/icons/IconSelect'
import { IconSelectOpen } from '@consta/icons/IconSelectOpen'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import { textProps } from '@core/core/helpers'
import { getStringFromNumbersOnly } from '@core/core/utils'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import type { LayersMenuReductionLevelProps } from './types'
import css from './VelocitySimulationRightMenu.css'

const onValuesChange = (
  value: string,
  keyLabel: string,
  setReductionLevel: LayersMenuReductionLevelProps['setReductionLevel'],
) => {
  const val = getStringFromNumbersOnly(value)
  setReductionLevel(prevState => ({
    ...prevState,
    reductionLevel: { ...prevState.reductionLevel, [keyLabel]: val ? value : null },
  }))
}

export const LayersMenuReductionLevel: FC<LayersMenuReductionLevelProps> = ({
  isLevelCollapsed,
  setIsLevelCollapsed,
  setReductionLevel,
  reductionLevel,
}) => {
  const iconLeft = !isLevelCollapsed ? IconSelectOpen : IconSelect
  const toggleCollapse = () => {
    setIsLevelCollapsed(prevState => !prevState)
  }

  const onSpeedChange = (value: Nullable<string>) => {
    onValuesChange(value ?? '', 'speed', setReductionLevel)
  }
  const onDepthChange = (value: Nullable<string>) => {
    onValuesChange(value ?? '', 'depth', setReductionLevel)
  }

  return (
    <div className={css.layersContainer}>
      <div className={css.layersWrapper}>
        <Button
          iconLeft={iconLeft}
          view="clear"
          size="xs"
          onlyIcon={true}
          onClick={toggleCollapse}
        />
        <Text {...textProps}>Уровень приведения</Text>
      </div>
      {!isLevelCollapsed && (
        <div className={css.layersMenuReductionLevelFields}>
          <div className={css.layersMenuFields}>
            <Text
              size="xs"
              lineHeight="2xs"
              view="secondary"
              className={css.layersTextPaddingBottom}>
              Глубина, м
            </Text>
            <TextField
              size="xs"
              withClearButton={true}
              className={css.layersMenuTextFields}
              type="number"
              min={0}
              value={reductionLevel.depth?.toString() ?? ''}
              onChange={onDepthChange}
            />
          </div>
          <div className={css.layersMenuFields}>
            <Text
              size="xs"
              lineHeight="2xs"
              view="secondary"
              className={css.layersTextPaddingBottom}>
              Скорость, м/c
            </Text>
            <TextField
              size="xs"
              withClearButton={true}
              className={css.layersMenuTextFields}
              type="number"
              min={0}
              value={reductionLevel.speed?.toString() ?? ''}
              onChange={onSpeedChange}
            />
          </div>
        </div>
      )}
    </div>
  )
}
